import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TextField, Select } from 'redux-form-material-ui';
import {
  Field, change, Form,
} from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { FORM_NAME, FORM_DEFINITION } from './index';
import { save } from '../../../redux/actions/invoiceActions';
import { NumberNormalize } from '../../normalize';
import { getWorkflowsByHoldingId } from '../../../redux/actions/workflowActions';
import { getAuthUser } from '../../../redux/actions/authActions';

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
  save,
  getWorkflowsByHoldingId,

}, dispatch);

const user = getAuthUser();

export class CompanyForm extends Component {

  static propTypes = {

  };

    static defaultProps = {

    };

    constructor(props) {

      super(props);

      this.onSubmit = this.onSubmit.bind(this);

      this.state = {
        workflows: [],
      };

    }

    componentDidMount() {

      const { reset, getWorkflowsByHoldingId } = this.props;

      reset();

      setTimeout(() => {

        getWorkflowsByHoldingId(user.context.idHolding).then(workflows => this.setState({ workflows }));

      }, 100);

    }

    onSubmit(data) {

      const { save, dispatch } = this.props;

      return save(data).then(() => true, (errors) => {

        throw errors;

      });

    }


    render() {

      const {
        submitting,
        handleSubmit,

      } = this.props;

      const { workflows } = this.state;

      return (

        <div>
          <Form form={FORM_NAME} onSubmit={handleSubmit(this.onSubmit)}>

            <div>
              <Field
                name="invoiceNumber"
                component={TextField}
                label={I18n.t('fields.invoiceNumber')}
                fullWidth
                normalize={NumberNormalize}
                disabled={submitting}
              />

              <Field
                name="codeBar"
                component={TextField}
                label={I18n.t('fields.codeBar')}
                fullWidth
                normalize={NumberNormalize}
                disabled={submitting}
              />


              <FormControl fullWidth>
                <InputLabel htmlFor="workflowId">{I18n.t('fields.workflow')}</InputLabel>
                <Field
                  name="workflowId"
                  component={Select}
                  fullWidth
                  disabled={submitting}

                >
                  {workflows.map(item =>
                    (<MenuItem
                      key={item.workFlowId}
                      value={item.workFlowId}
                    >{item.name}
                    </MenuItem>)
                  )}

                </Field>

                <Field
                  name="expiration"
                  component={TextField}
                  label={`${I18n.t('fields.expiration_time')}  (${I18n.t('fields.in_hours')})`}
                  fullWidth
                  normalize={NumberNormalize}
                  disabled={submitting}
                />
              </FormControl>

            </div>

          </Form>

        </div>
      );

    }
}


export default FORM_DEFINITION(
  connect(mapStateToProps, mapDispatchToProps)(CompanyForm),
);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoices/InvoiceReduxForm.js